import {Component, Input, OnInit} from "@angular/core";

@Component({
  selector: 'tx-display',
  templateUrl: './tx-display.component.html',
  styleUrls: ['./tx-display.component.css']
})
export class TxDisplayComponent implements OnInit {

  _file: any;

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set file(file) {
    this._file = file;
  }

  get file() {
    return this._file;
  }

  openFile() {
      window.open(this.file.path, '_blank');
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-display/tx-display.component.ts